module.exports = __webpack_public_path__ + "img/chevron-up.69954eb6.svg";